import React, {Component} from 'react'
import ClaimList from "./ClaimList";

export default class SelfPayClaimList extends Component {

    render() {
        return <ClaimList {...this.props} listParams={{selfPay: true}}/>;
    }
}
